// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products-header {
  background-color: transparent;
  box-shadow: 0 0 1px 0 rgba(212, 154, 32, 0.15), 0 6px 12px 0 rgba(212, 154, 32, 0.15), 0 0 2px 1px rgba(212, 154, 32, 0.15) inset;
  padding: 0.35rem;
  border-radius: 4px;
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 4rem;
}
@media only screen and (max-width: 1199px) {
  .products-header {
    top: calc(10px + var(--header-height));
    z-index: 12;
    background: #121212;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: clip;
    margin-inline: auto;
  }
}
.products-header * {
  z-index: 2;
}
.products-header .tab {
  height: 54px;
  width: 180px;
  min-width: 180px;
  border-radius: 99px;
  transition: color 0.15s ease-in;
}
.products-header .tab:nth-of-type(1) {
  width: 140px;
  min-width: 140px;
}
.products-header .tab:nth-of-type(2) {
  width: 180px;
  min-width: 180px;
}
.products-header .tab:nth-of-type(3) {
  width: 160px;
  min-width: 160px;
}
@media only screen and (max-width: 1199px) {
  .products-header .tab:nth-of-type(1) {
    width: 100px;
    min-width: 100px;
  }
  .products-header .tab:nth-of-type(2) {
    width: 140px;
    min-width: 140px;
  }
  .products-header .tab:nth-of-type(3) {
    width: 120px;
    min-width: 120px;
  }
}
.products-header .notification {
  padding: 0.25rem 0.75rem;
  margin-left: 0.75rem;
  border-radius: 99px;
  background-color: var(--surface-a);
  transition: 0.15s ease-in;
  font-size: 14px;
}
@media only screen and (max-width: 1199px) {
  .products-header .notification {
    font-size: 11px;
    padding: 0.125rem 0.5rem;
    margin-left: 0.5rem;
  }
}
.products-header input[type=radio]:checked + label {
  color: var(--primary-color);
}
.products-header input[type=radio]:checked + label > .notification {
  background-color: var(--primary-color);
  color: var(--surface-background);
}
.products-header .glider {
  height: 54px;
  width: 180px;
  border: 2px solid var(--primary-color);
  border-radius: 4px;
  transition: 0.25s ease-out;
}
@media only screen and (max-width: 1199px) {
  .products-header .glider {
    width: 160px;
  }
}
.products-header input[id=radio-1]:checked ~ .glider {
  transform: translateX(0);
  width: 140px;
}
@media only screen and (max-width: 1199px) {
  .products-header input[id=radio-1]:checked ~ .glider {
    width: 100px;
  }
}
.products-header input[id=radio-2]:checked ~ .glider {
  transform: translateX(140px);
  width: 180px;
}
@media only screen and (max-width: 1199px) {
  .products-header input[id=radio-2]:checked ~ .glider {
    transform: translateX(100px);
    width: 140px;
  }
}
.products-header input[id=radio-3]:checked ~ .glider {
  transform: translateX(320px);
  width: 160px;
}
@media only screen and (max-width: 1199px) {
  .products-header input[id=radio-3]:checked ~ .glider {
    width: 120px;
    transform: translateX(240px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/products/components/product-header/product-header.component.scss"],"names":[],"mappings":"AAYA;EACE,6BAAA;EACA,iIAAA;EAGA,gBAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;AAbF;AANE;EAWF;IAWI,sCAAA;IACA,WAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;EAZF;AACF;AAcE;EACE,UAAA;AAZJ;AAeE;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AAbJ;AAeI;EACE,YAAA;EACA,gBAAA;AAbN;AAgBI;EACE,YAAA;EACA,gBAAA;AAdN;AAiBI;EACE,YAAA;EACA,gBAAA;AAfN;AAvCE;EA0DI;IACE,YAAA;IACA,gBAAA;EAhBN;EAmBI;IACE,YAAA;IACA,gBAAA;EAjBN;EAoBI;IACE,YAAA;IACA,gBAAA;EAlBN;AACF;AAsBE;EACE,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kCAAA;EACA,yBAAA;EACA,eAAA;AApBJ;AA7DE;EA2EA;IASI,eAAA;IACA,wBAAA;IACA,mBAAA;EAnBJ;AACF;AAwBM;EACE,2BAAA;AAtBR;AAwBQ;EACE,sCAAA;EACA,gCAAA;AAtBV;AA4BE;EACE,YAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,0BAAA;AA1BJ;AAlFE;EAuGA;IAQI,YAAA;EAzBJ;AACF;AA8BM;EACE,wBAAA;EACA,YAAA;AA5BR;AA3FE;EAqHI;IAKI,YAAA;EA3BR;AACF;AAkCM;EACE,4BAAA;EACA,YAAA;AAhCR;AApGE;EAkII;IAKI,4BAAA;IACA,YAAA;EA/BR;AACF;AAsCM;EACE,4BAAA;EACA,YAAA;AApCR;AA9GE;EAgJI;IAKI,YAAA;IACA,4BAAA;EAnCR;AACF","sourcesContent":["@mixin md() {\r\n  @media only screen and (max-width: 1199px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin mu() {\r\n  @media only screen and (min-width: 1200px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n.products-header {\r\n  background-color: transparent;\r\n  box-shadow: 0 0 1px 0 rgba(212, 154, 32, 0.15),\r\n    0 6px 12px 0 rgba(212, 154, 32, 0.15),\r\n    0 0 2px 1px rgba(212, 154, 32, 0.15) inset;\r\n  padding: 0.35rem;\r\n  border-radius: 4px;\r\n  width: fit-content;\r\n  margin-bottom: 4rem;\r\n\r\n  @include md() {\r\n    top: calc(10px + var(--header-height));\r\n    z-index: 12;\r\n    background: #121212;\r\n    max-width: 100%;\r\n    overflow-x: auto;\r\n    overflow-y: clip;\r\n    margin-inline: auto;\r\n  }\r\n\r\n  * {\r\n    z-index: 2;\r\n  }\r\n\r\n  .tab {\r\n    height: 54px;\r\n    width: 180px;\r\n    min-width: 180px;\r\n    border-radius: 99px;\r\n    transition: color 0.15s ease-in;\r\n\r\n    &:nth-of-type(1) {\r\n      width: 140px;\r\n      min-width: 140px;\r\n    }\r\n\r\n    &:nth-of-type(2) {\r\n      width: 180px;\r\n      min-width: 180px;\r\n    }\r\n\r\n    &:nth-of-type(3) {\r\n      width: 160px;\r\n      min-width: 160px;\r\n    }\r\n\r\n    @include md() {\r\n      &:nth-of-type(1) {\r\n        width: 100px;\r\n        min-width: 100px;\r\n      }\r\n\r\n      &:nth-of-type(2) {\r\n        width: 140px;\r\n        min-width: 140px;\r\n      }\r\n\r\n      &:nth-of-type(3) {\r\n        width: 120px;\r\n        min-width: 120px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .notification {\r\n    padding: 0.25rem 0.75rem;\r\n    margin-left: 0.75rem;\r\n    border-radius: 99px;\r\n    background-color: var(--surface-a);\r\n    transition: 0.15s ease-in;\r\n    font-size: 14px;\r\n\r\n    @include md() {\r\n      font-size: 11px;\r\n      padding: 0.125rem 0.5rem;\r\n      margin-left: 0.5rem;\r\n    }\r\n  }\r\n\r\n  input[type=\"radio\"] {\r\n    &:checked {\r\n      & + label {\r\n        color: var(--primary-color);\r\n\r\n        & > .notification {\r\n          background-color: var(--primary-color);\r\n          color: var(--surface-background);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .glider {\r\n    height: 54px;\r\n    width: 180px;\r\n    border: 2px solid var(--primary-color);\r\n    border-radius: 4px;\r\n    transition: 0.25s ease-out;\r\n\r\n    @include md() {\r\n      width: 160px;\r\n    }\r\n  }\r\n\r\n  input[id=\"radio-1\"] {\r\n    &:checked {\r\n      & ~ .glider {\r\n        transform: translateX(0);\r\n        width: 140px;\r\n\r\n        @include md() {\r\n          width: 100px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  input[id=\"radio-2\"] {\r\n    &:checked {\r\n      & ~ .glider {\r\n        transform: translateX(140px);\r\n        width: 180px;\r\n\r\n        @include md() {\r\n          transform: translateX(100px);\r\n          width: 140px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  input[id=\"radio-3\"] {\r\n    &:checked {\r\n      & ~ .glider {\r\n        transform: translateX(320px);\r\n        width: 160px;\r\n\r\n        @include md() {\r\n          width: 120px;\r\n          transform: translateX(240px);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
